// Product data for different filter models
export const PRODUCT_MODELS = [
  {
    id: 'sf-compact',
    name: 'SmartFilter Compact',
    price: 299,
    dimensions: {
      width: { min: 60, max: 100 },
      height: { min: 80, max: 150 },
      depth: 2.5
    },
    features: [
      'Blocage UV 98%',
      'Installation clip-on',
      'Alimentation solaire',
      'Garantie 5 ans'
    ],
    image: 'https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?w=400&h=400&fit=crop',
    inStock: true,
    recommended: false
  },
  {
    id: 'sf-standard',
    name: 'SmartFilter Standard',
    price: 449,
    dimensions: {
      width: { min: 100, max: 150 },
      height: { min: 150, max: 220 },
      depth: 3.0
    },
    features: [
      'Blocage UV 98%',
      'Installation clip-on',
      'Alimentation solaire',
      'Contrôle app',
      'Garantie 5 ans'
    ],
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&h=400&fit=crop',
    inStock: true,
    recommended: true
  },
  {
    id: 'sf-premium',
    name: 'SmartFilter Premium',
    price: 649,
    dimensions: {
      width: { min: 150, max: 220 },
      height: { min: 220, max: 300 },
      depth: 3.5
    },
    features: [
      'Blocage UV 99%',
      'Installation pro',
      'Alimentation solaire',
      'Contrôle app avancé',
      'Mode hiver/été auto',
      'Garantie 10 ans'
    ],
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=400&fit=crop',
    inStock: true,
    recommended: false
  },
  {
    id: 'sf-panoramic',
    name: 'SmartFilter Panoramic',
    price: 899,
    dimensions: {
      width: { min: 220, max: 350 },
      height: { min: 200, max: 280 },
      depth: 4.0
    },
    features: [
      'Blocage UV 99%',
      'Installation pro',
      'Double alimentation',
      'Contrôle app premium',
      'Mode intelligent adaptatif',
      'Télémétrie avancée',
      'Garantie 10 ans'
    ],
    image: 'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=400&h=400&fit=crop',
    inStock: true,
    recommended: false
  }
];

export const WINDOW_DIMENSIONS = {
  width: { min: 60, max: 350, step: 10 },
  height: { min: 80, max: 300, step: 10 },
  depth: { options: [2.5, 3.0, 3.5, 4.0, 4.5, 5.0] }
};
